import { useState } from 'react';
import { deleteCorporateCommunicated } from '../CorporateCommunicated.service';
import { useSnackbar } from '../../../context/Snackbar';
import { useHistory } from "react-router-dom";
import ModalDelete from '../../../component/modal/ModalDelete.component';
import { MouseEvent } from 'react';

interface DeleteInterface {
    open: string | number | boolean | undefined;
    handleClick(event?: MouseEvent<HTMLElement>): void;
}

export default function Delete({ open, handleClick }: DeleteInterface) {

    let history = useHistory();
    const { setSnackbar } = useSnackbar();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const handleClickDelete = async () => {
        setIsSubmitting(true);
        await deleteCorporateCommunicated(String(open)).then(res => {
            setSnackbar({ msg: "Comunicado excluído com sucesso!", type: 'success' });
            history.push(`/comunicado-corporativo`);
        }).catch(error => {
            console.log('Error ao excluir comunicado', error);
            setSnackbar({ msg: "Erro ao excluir comunicado!", type: 'error' });
        }).finally(function () {
            handleClick(undefined)
            setIsSubmitting(false);
        });
    };

    return (
        <ModalDelete open={!!open && open !== 'historico'} handleClick={() => handleClick(undefined)} onClickSubmit={handleClickDelete} title="Confirma a exclusão desse comunicado?" disabled={isSubmitting} />
    );
}
